export const useRemoveSpace = (str) => {
  return str?.length >= 1 && str?.replace(/ /g, '-');
};
